require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-ux-designer-india.json") })
        }
      }, "path---careers-ux-designer-india");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-ux-designer-india!./.cache/json/careers-ux-designer-india.json
// module id = 883
// module chunks = 231608221292675